import { render, staticRenderFns } from "./DetailComponentRoom.vue?vue&type=template&id=26b286f6&"
import script from "./DetailComponentRoom.vue?vue&type=script&lang=js&"
export * from "./DetailComponentRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports